import i18n from '@/settings/i18n';

const t = i18n.init('business');

const STEPS = [
  {
    title: 'Create your account',
    description: 'Sign in or sign up with your business details.',
  },
  {
    title: 'Submit your certificate',
    description: 'Complete the guided form or upload your exemption documents.',
  },
  {
    title: 'Place your orders',
    description:
      'Once validated, your orders are automatically tax-free at checkout.',
  },
] as const;

const TaxExemptSteps = () => (
  <div className="bg-white py-8 md:py-10">
    <ol className="reebelo-container md:max-w-3xl grid grid-cols-1 gap-6 sm:grid-cols-3 md:mx-auto">
      {STEPS.map(({ title, description }, index) => (
        <li key={title} className="flex flex-col items-center text-center">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-700 text-xs font-bold text-white">
            {index + 1}
          </span>
          <span className="mt-3 text-sm font-medium">{t(title)}</span>
          <span className="mt-1 max-w-[220px] text-xs text-gray-700/60">
            {t(description)}
          </span>
        </li>
      ))}
    </ol>
  </div>
);

export default TaxExemptSteps;
